namespace e5 {
    export class FullscreenUtil {

        public static onChange = e5.Signal.create<[boolean, HTMLElement]>();

        public static get isSupported(): boolean {
            return (<any>document).fullscreenEnabled ||
                (<any>document).webkitFullscreenEnabled ||
                (<any>document).mozFullScreenEnabled ||
                (<any>document).msFullscreenEnabled;
        }

        public static get element(): HTMLElement {
            return (<any>document).fullscreenElement ||
                (<any>document).webkitFullscreenElement ||
                (<any>document).mozFullScreenElement ||
                (<any>document).msFullscreenElement;
        }

        public static enter(element: HTMLElement): void {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if ((<any>element).mozRequestFullScreen) {
                (<any>element).mozRequestFullScreen();
            } else if ((<any>element).msRequestFullscreen) {
                (<any>element).msRequestFullscreen();
            } else if ((<any>element).webkitRequestFullscreen) {
                (<any>element).webkitRequestFullscreen();
            } else if ((<any>element).webkitRequestFullScreen) {
                (<any>element).webkitRequestFullScreen();
            }
            else {
                console.log("Could not find any fullscreen method....");
            }
        }

        public static toggle(element: HTMLElement): boolean {
            if (FullscreenUtil.active) {
                FullscreenUtil.exit();
                return false;
            }
            else {
                FullscreenUtil.enter(element);
                return true;
            }
        }

        public static exit(): void {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if ((<any>document).mozCancelFullScreen) {
                (<any>document).mozCancelFullScreen();
            } else if ((<any>document).webkitExitFullscreen) {
                (<any>document).webkitExitFullscreen();
            }
        }

        public static get active(): boolean {
            return Boolean(FullscreenUtil.element);
        }
    }

    for (var evt of ["fullscreenchange", "mozfullscreenchange", "webkitfullscreenchange"]) {
        document.addEventListener(evt, () => {
            FullscreenUtil.onChange.dispatch(FullscreenUtil.active, FullscreenUtil.element);
        });
    }
}